<template>
  <IQOSModal @backdropClick="onClose">
    <template #title>
      {{ $t('add_corporate_cafe.modal_title') }}
    </template>

    <BaseTabSwitcher 
      v-model="as_chain"
      v-if="!base_id"
      :tabs="[{
        text: $t('add_corporate_cafe.tab_chain'),
        value: true
      }, {
        text: $t('add_corporate_cafe.tab_cafe'),
        value: false,
      }]"
      class="w-100 mt-16"/>

    <BaseDivider color="v1-grey-5" class="mt-16 mb-16" v-if="!base_id"/>

    <div v-if="as_chain">
      <BaseInput
        :readonly="false"
        fullWidth
        :placeholder="$t('add_corporate_cafe.chain_ph')"
        v-model="chain_name"
      />
    </div>

    <div v-else>
      <BaseSelect class="mb-16" v-if="chains.length > 0" v-model="create_data.chain_id">
        <option :value="null">
          {{ $t('add_corporate_cafe.no_chain') }}
        </option>
        <option :value="chain._id" :key="chain._id" v-for="chain in chains">
           {{ chain.name }}
        </option>
      </BaseSelect>
      <BaseInput
        fullWidth
        :placeholder="$t('add_corporate_cafe.name_ph')"
        :valid="valid || !!create_data.name"
        v-model="create_data.name"
      />
      <BaseInput
        inputId="gmapAddressField"
        :readonly="false"
        class="mt-16"
        fullWidth
        :placeholder="$t('add_corporate_cafe.address_ph')"
        :valid="valid || !!create_data.address"
        v-model="create_data.address"
      />

      <p class="qrw-paragraph-md modal-comment v1-grey-6-color mt-16">
         {{ $t("add_corporate_cafe.new_desc") }}
      </p>
    </div>

    <template #actions>
      <BaseButton variant="secondary" color="v1-grey-6" size="md" class="w-100" @click="onClose">{{
          $t("add_corporate_cafe.cancel")
        }}
      </BaseButton>
      
      <BaseButton 
        @click="createChain"
        v-if="as_chain"
        variant="secondary"
        color="green-5"
        class="w-100" 
        size="md"
        :disabled="!chain_name || chain_name.length < 2">{{
          $t("add_corporate_cafe.add_chain")
      }}</BaseButton>

      <BaseButton 
        @click="onConfirm"
        v-else
        variant="secondary"
        color="green-5"
        class="w-100" 
        size="md"
        :disabled="!create_data.name || !create_data.address">{{
          $t("add_corporate_cafe.register")
      }}</BaseButton>
    </template>
  </IQOSModal>
</template>

<script>
import CafeAPI from "@/api/cafe";

import ChainAPI from "@/api/chain"

let gmapAutocomplete = null;

export default {
  props: {
    chain_id: String,
    base_id: String
  },
  data() {
    return {
      as_new: true,

      as_chain: false,

      create_data: {
        base_id: null,
        name: null,
        address: null,
        address_location: null,
        city: null,
        chain_id: null
      },

      chain_name: null,

      valid: true,
    };
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    onConfirm() {
      if (!this.create_data.name || !this.create_data.address) {
        this.valid = false;
        return;
      }

      if (this.chain_id) {
        this.create_data.chain_id = this.chain_id;
      }

      this.valid = true;

      CafeAPI.createCorporateCafe(this.create_data)
        .then((data) => {
          this.$store.dispatch("auditlog/write", {
            type: "create_cafe",
            payload: this.create_data
          });
          this.$emit("created");
          this.onClose();
        })
        .catch((error) => {
          alert(error);
        });
    },
    createChain() {
      ChainAPI.createChain(
        {
          name: this.chain_name,
          logo: null,
          price_level: '$',
          description: null,
          food_flavors: []
        }
      ).then(data => {
        this.$store.commit('selectChain', data.chain);
        this.$store.dispatch('fetchCorporateCafes').then(() => {
          this.$emit('close');
        });
        
      })
    },
    initGoogleWidget() {
      const el = document.getElementById("gmapAddressField");

      const autocomplete = new window.google.maps.places.Autocomplete(el, {
        types: ["geocode"],
      });

      autocomplete.setFields([
        "formatted_address",
        "address_component",
        "geometry",
      ]);

      autocomplete.setComponentRestrictions({
        country: "ua",
      });

      autocomplete.addListener(
        "place_changed",
        this.onGmapPlaceChange.bind(this)
      );

      gmapAutocomplete = autocomplete;
    },
    onGmapPlaceChange() {
      if (gmapAutocomplete) {
        const place = gmapAutocomplete.getPlace();

        const components = place.address_components;

        const locality_component = components.find(
          (c) => c.types.includes("locality") || c.types.includes("political")
        );

        this.create_data.city = locality_component.long_name || "?";

        this.create_data.address = place.formatted_address;

        this.create_data.address_location = {
          lat: place.geometry.location.lat(),
          lon: place.geometry.location.lng(),
        };
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initGoogleWidget();
    });

    if (this.chain_id) {
      this.as_chain = false;
    }

    if (this.base_id) {
      this.create_data.base_id = this.base_id;

      const base_cafe = this.corporate_cafes.find(c => c._id == this.base_id);

      if (base_cafe) {
        this.create_data.name = base_cafe.name;
        this.create_data.chain_id = base_cafe.chain_id || null;
      }

      this.as_chain = false;
    }
  },
  computed: {
    corporate_cafes() {
      return this.$store.state.corporate_cafes;
    },
    chains() {
      return this.$store.state.chains;
    }
  },
};
</script>

<style scoped>
.modal-comment {
  width: 100%;
  text-align: center;
}
</style>